import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';

import { useMarginAccount } from 'src/lib/margin/hooks/account';
import { getMarginRiskTitle } from 'src/lib/margin/utils';

const MarginAccountHealthMarginDescription: React.FC = () => {
  const { t } = useTranslation('margin');
  const { usedMargin, marginLevel } = useMarginAccount();

  return (
    <FlexLayout spacing={8} direction='column' alignItems='start' className='hidden w-full sm:flex'>
      <Body color='secondary' size='xsmall' className='block md:hidden'>
        {t('accountOverview.description.title')}
      </Body>
      <Body>{t(`accountHealth.riskRating.description.${getMarginRiskTitle(usedMargin, marginLevel)}`)}</Body>
    </FlexLayout>
  );
};

export { MarginAccountHealthMarginDescription };
